import {IonAvatar, IonBadge, IonButton, IonCol, IonIcon, IonNote, IonRouterLink, IonSelect, IonSelectOption, IonText, useIonAlert, useIonRouter} from "@ionic/react";
import styles_CardDetailFor_7_4 from "./CardDetailFor_7_4.module.scss";
import styles_ContractBonusItem from "./ContractBonusItem.module.scss";
import {bookmark, bookmarkOutline, chatboxEllipses, chatboxEllipsesOutline, heart, heartOutline, star} from "ionicons/icons";
import Ln_TokenPictureSetCoverImg from "../pages/Ln_TokenPictureSetCoverImg";
import {ActionLink} from "./ActionLink";
import styles_Common from "../pages/Common.module.scss";
import moment from "moment";
import QRCode from "react-qr-code";
import {useStoreState} from "pullstate";
import {AuthStore, UserEventActivityStore} from "../store/Common_Store";
import {getPageData} from "../store/Selectors";
import useForceRender from "../_/useForceRender";
import styles_Pg_C_1 from "../pages/Pg_C_1.module.scss";
import {constPetCategory} from "../_/constant";
import React, {useState} from "react";
import CustomField from "./CustomField";
import indexBy from "underscore/modules/indexBy";
import {useTokenEnwDetailEditFields} from "./TokenEnwDetailItem";
import {useFormInput, validateForm} from "../_/useForms";
import styles_CardDetailFor_7_2 from "./CardDetailFor_7_2.module.scss";
import {navToPg_1_1, navToPg_7_5, navToPg_7_6, promptBrowserToLogin} from "../pages/Utils";
import {push__pg_7_4_1__buy, push_pg_7_3_1_JoinEvent} from "../store/Pg_7_Store";

const 商品規格 = {
    header: '商品規格',
    subHeader: '',
    message: '請選擇一項',
    translucent: false,
};

export const useProductEditFields = (Item_Product: any) => {
    return [
        {
            id: "ProductModelId",
            label: "規格",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "規格",
                },
                state: useFormInput(Item_Product.ProductModelId__ListDefault)
            }
        },
    ];
}

export const CardDetailFor_7_4_1 = ({
                                        Item_Product,
                                        fromHome = false,
                                        noLink = false,
                                        onClickCapture = null as any
                                    }) => {
    const router = useIonRouter();
    //const eventJoins = useStoreState(UserEventJoinStore, getPageData);
    const forceRender = useForceRender();

    ///#region 會員
    const authStore = useStoreState(AuthStore, getPageData);
    const hasAuthed = authStore?.signBy ?? false;
    const Item_會員 = hasAuthed ? authStore?.AuthData : undefined;
    ///#endregion

    const [presentAlert] = useIonAlert();


    const [errors, setErrors] = useState(false);
    const fields = useProductEditFields(Item_Product);
    let keyedFields = indexBy(fields, 'id');

    if (!Item_Product) {
        return <>(ERROR:Item_Product)</>;
    }

    let _Category: any = Item_Product?._Category;
    if (!_Category) {
        return <>(ERROR:_Category)</>;
    }

    let _Models: any = Item_Product?._Models;
    if (!_Models) {
        return <>(ERROR:_Models)</>;
    }

    let keyedModel = indexBy(Item_Product._Models, 'ProductModelId');



    const _push__pg_7_4_1__buy = async () => {
        if (!hasAuthed) {
            promptBrowserToLogin();
            return;
        }

        let myGatherFields = await gatherFields();

        if (myGatherFields === null) {
            return;
        }

        if (await push__pg_7_4_1__buy({
            p1: Item_Product.ProductId,
            p2: myGatherFields.ProductModelId,
        })) {
            //navToPg_7_5();
            //reload();

            presentAlert({
                backdropDismiss: false,
                keyboardClose: false,
                header: '兌換成功！',
                //subHeader: 'A Sub Header Is Optional',
                message: Item_Product.Name,
                buttons: [
                    // {
                    //     text: 'Cancel',
                    //     role: 'cancel',
                    //     handler: () => {
                    //         console.log('Alert canceled');
                    //     },
                    // },
                    {
                        text: '查詢點數兌換紀錄',
                        role: 'confirm',
                        handler: () => {
                            navToPg_7_6(router, {clearStore: true});
                        },
                    },
                ]
            })
        }
    }

    //#region Field Event
    const gatherFields = async () => {
        const errors = validateForm(fields);
        setErrors(errors);

        if (!errors.length) {
            //  Submit your form here
            //const username = fields && (fields.filter(e => e.id === 'email')[0] as any).input.state.value;
            //const password = fields && (fields.filter(e => e.id === 'password')[0] as any).input.state.value;

            //const scodeEmail = fields && (keyedFields.scodeEmail as any).value;
            //const vcodeEmail = fields && (keyedFields.vcodeEmail as any).value;
            //const scodePhone = fields && (keyedFields.scodePhone as any).value;
            //const vcodePhone = fields && (keyedFields.vcodePhone as any).value;

            // let {email, scodeEmail, vcodeEmail} = Pg_B_1_Store.getRawState() as any;
            // let {phone, scodePhone, vcodePhone} = Pg_C_4_Store.getRawState() as any;
            //
            // if (emailVerifyStage !== 4 && emailVerifyStage !== 0) {
            //     alert("因為電子信箱改變過，請再次先完成Email驗證流程");
            //     return;
            // }
            // if (phoneVerifyStage !== 4 && phoneVerifyStage !== 0) {
            //     alert("因為手機號改變過，請再次先完成手機驗證流程");
            //     return;
            // }
            //

            const ProductModelId = fields && (keyedFields.ProductModelId as any).input.state.value;


            // //const password = fields && (fields.filter(e => e.id === 'password')[0] as any).input.state.value;
            // //const password = fields && (fields.filter(e => e.id === 'password')[0] as any).input.state.value;
            //
            // try {
            //     if (await push_pg_0_3({
            //         PetPhoto,
            //         PetName,
            //         PetCategory,
            //         PetBreed,
            //         PetSex,
            //         PetSterillization,
            //         PetBirthday,
            //         PetChip,
            //         Edition,
            //     })) {
            //         alert('更新成功')
            //         //reload();
            //     }
            // } catch (err) {
            // }

            return {
                ProductModelId: ProductModelId,
            }
        }

        return null;
    }
    //#endregion

    return (
        <>
            <ActionLink link={`/tabs/4_4/${Item_Product.ProductId}`} className={styles_CardDetailFor_7_4.container} noLink={noLink} onClickCapture={onClickCapture}>
                <div className={styles_CardDetailFor_7_4.postBar}>
                    {Ln_TokenPictureSetCoverImg({
                        圖片組: Item_Product.封面組,
                        名稱: 'cover',
                    })}
                </div>

                <div className={styles_CardDetailFor_7_4.containerInner}>


                    <div className={styles_ContractBonusItem.nameBar}>
                        <div className="container">
                            {/*<div className="l">*/}
                            {/*    <IonAvatar className="avatar">*/}
                            {/*        {Ln_TokenPictureSetCoverImg({*/}
                            {/*            圖片組: Item_Token_會員公開.個人照片,*/}
                            {/*            名稱: 'cover',*/}
                            {/*        })}*/}
                            {/*    </IonAvatar>*/}
                            {/*</div>*/}
                            {/*<div className="r">*/}
                            {/*    {Item_Token_會員公開.暱稱}*/}
                            {/*</div>*/}
                            <div className="r2">
                                <div className="roundbg">
                                    {Item_Product.Name}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={styles_CardDetailFor_7_4.titleBar}>
                        {Item_Product.Name}
                    </div>

                    <div className={styles_ContractBonusItem.timeRangeBar}>
                        點數: {keyedModel[keyedFields.ProductModelId.input.state.value].RedeemCostPoint * -1}
                    </div>

                    <div className={styles_ContractBonusItem.timeRangeBar}>
                        原價: {keyedModel[keyedFields.ProductModelId.input.state.value].ModelListPrice} TWD
                    </div>

                    <div className={styles_ContractBonusItem.timeRangeBar}>
                        款式:

                        <CustomField noLabelSlot={false} alternateLeftZone={<>
                            <IonSelect interfaceOptions={商品規格} value={keyedFields.ProductModelId.input.state.value} interface="action-sheet" placeholder="選取規格" onIonChange={(ev) => {
                                keyedFields.ProductModelId.input.state.reset(ev.detail.value);
                            }}
                                       multiple={false} className={styles_Pg_C_1.select}>
                                {_Models.map((v) => {
                                    return <IonSelectOption key={v.ModelName} value={v.ProductModelId}>{v.ModelName}</IonSelectOption>
                                })}
                            </IonSelect>
                        </>} field={keyedFields.ProductModelId} errors={errors} isHideField={true}/>
                    </div>

                    {/*<div className={styles_ContractBonusItem.timeRangeBar}>*/}
                    {/*    使用期限: {moment(Item_合約獎勵.起始生效區間).format('YYYY/MM/DD')} - {moment(Item_合約獎勵.生效區間結束).format('YYYY/MM/DD')}*/}
                    {/*</div>*/}

                    <div className={styles_CardDetailFor_7_4.containerInner}>
                        兌換相關資訊
                        <div>
                            可至全台全家便利店兌換領取（以店點的實際庫存量為準，若庫存不足請改至其他門店兌換另取）。
                            兌換後，限 7 天內領取，過期未領取即失效。
                        </div>
                    </div>

                    {keyedModel[keyedFields.ProductModelId.input.state.value].ModelRemainingRedeemableQuantity > 0 &&
                        <IonButton className={styles_CardDetailFor_7_2.buttonCanDo} fill={"solid"} onClick={() => _push__pg_7_4_1__buy()} expand="block">
                            立刻兌換
                        </IonButton>
                    }

                    <div className={styles_CardDetailFor_7_4.contentBar}>
                        {/*<li className="l">介紹</li>*/}
                        <IonText className="c" dangerouslySetInnerHTML={{__html: Item_Product.Description}}/>
                    </div>
                </div>

                {/*<div className={styles_CardDetailFor_7_4.containerInner}>*/}
                {/*    {(QrCode !== null) ? <>*/}
                {/*        {Item_合約獎勵.兌換時間 ? <>*/}
                {/*                <div className={styles_CardDetailFor_7_4.redeemBar}>*/}
                {/*                    <div className="l">已兌換</div>*/}
                {/*                </div>*/}
                {/*            </> :*/}
                {/*            <>*/}
                {/*                <div className={styles_CardDetailFor_7_4.redeemBar}>*/}
                {/*                    <div className="l">掃描 QR code 兌換</div>*/}
                {/*                    <div className="c" style={{height: "auto", margin: "0 auto", maxWidth: 125, width: "100%"}}>*/}
                {/*                        <QRCode*/}
                {/*                            size={256}*/}
                {/*                            style={{height: "auto", maxWidth: "100%", width: "100%"}}*/}
                {/*                            value={QrCode}*/}
                {/*                            viewBox={`0 0 256 256`}*/}
                {/*                        />*/}
                {/*                    </div>*/}
                {/*                    <div className="f"></div>*/}
                {/*                </div>*/}
                {/*            </>*/}
                {/*        }*/}
                {/*    </> : <></>}*/}

                {/*    /!*<ul className={styles_CardDetailFor_7_4.timeRangeBar}>*!/*/}
                {/*    /!*    <li className="l">使用期限</li>*!/*/}
                {/*    /!*    <div className="c">*!/*/}
                {/*    /!*        {moment(Item_合約獎勵.起始生效區間).format('YYYY/MM/DD')} - {moment(Item_合約獎勵.生效區間結束).format('YYYY/MM/DD')}*!/*/}
                {/*    /!*    </div>*!/*/}
                {/*    /!*</ul>*!/*/}

                {/*    <div className={styles_CardDetailFor_7_4.qrBar}>*/}
                {/*        /!*<li className="l">使用狀態</li>*!/*/}
                {/*        <div className="c">*/}
                {/*            每個{Item_合約獎勵._合約.Name}孵化器可兌換{Item_合約獎勵.CanUseTimesPerTokenEnw}次，您共有{總共可兌換次數}次兌換機會（目前您已兌換{已兌換次數}次，尚可兌換{Math.max(0, 總共可兌換次數 - 已兌換次數)}次）。*/}
                {/*            /!*每個數位收藏，可兌換 {Item_合約獎勵.CanUseTimesPerTokenEnw} 次，共有 {總共可兌換次數} 次兌換。已兌換 {已兌換次數} 次，尚可兌換 {總共可兌換次數 - 已兌換次數} 次。*!/*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </ActionLink>
        </>
    );
}
